// Core imports
import * as React from 'react';

// Styling imports
import './RCheckbox.scss';

/* 
  RCheckbox: Reusable checkbox with transitions and design guidelines styling.
 */

const RCheckbox = (props: IRCheckboxProps) => {
  const { id, checked, color, usesLabel, label, onChanged, disabled } = props;
  const labelValue = usesLabel ? label : '';
  const checkboxType = props.type === 'box' ? 'rpd-check' : 'rpd-check-circle';

  return (
    <div
      className="rp-rcheckbox"
      onClick={() => {
        onChanged(!checked);
      }}
    >
      <input
        id={id}
        type="checkbox"
        className={`${checkboxType} ${color}`}
        checked={checked}
        readOnly={true}
        disabled={disabled}
      />
      <label
        htmlFor={`check`}
        className={`filter-check ${disabled ? 'is-disabled' : ''}`}
      >
        {labelValue}
      </label>
    </div>
  );
};

export default RCheckbox;

interface IRCheckboxProps {
  onChanged(value: boolean): void;
  color: 'blue' | 'green' | 'gray';
  checked: boolean;
  usesLabel: boolean;
  label?: string;
  id: string;
  type: 'box' | 'circle';
  disabled?: boolean;
}
